import React, { Component } from 'react';
import './section8.css';
import img1 from '../../asserts/vd-img.png'
import Title from '../common/title';
import Text from '../common/text';
import Btn from '../common/btn';

const section8 = () => {
  
    return ( 
        <section className='sec8-contanier'>
      <div className="sec8-image">
        <img src={img1} alt="Golden Hills Villa" className="sec8-img" />
      </div>

      <div className="sec8-content-wrapper">

        <div className="sec8-card sec8-card-top waves-bg">
                <div className="sec8-card-inner">
                    <Title title='Welcome to Golden Hills Villas' t='title' />
                    <Text text="Modern Living, Elevated" x='text' />
                </div>
        </div>

        <div className="sec8-card sec1-card-bottom">
          <div className="sec8-card-inner">
            <Text text="Golden Hills Apartments offer the perfect blend of style, comfort, and convenience. Designed for urban lifestyles, our apartments feature contemporary interiors, thoughtful layouts, and prime locations. Experience a home that fits your needs and enhances your daily life."  x='text' />
            <Btn btn='Explore Now' />
          </div>
        </div>

      </div>

        </section>
    );
}
 
export default section8;